import React,{useState} from 'react'
import { useFormik } from 'formik';
import OtpInput from 'react-otp-input';
import Reset from '../../Assets/images/reset.png';
import {createPinApi} from '../../Context/api';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
import {createPinValidation} from '../../Context/validation';
import Spinner from '../Spinner/spinner';
import { useNavigate, useParams } from 'react-router-dom';

const CreatePin = () => {
  const [spinner, setSpinner] = useState(false)
  const { token } = useParams()
  const navigate=useNavigate()

  const pinChange = useFormik({
    initialValues: {
      newPin: '',
      confirmNewPin: '',
    },
    validationSchema: createPinValidation,
    onSubmit: values => {
      const data = {
        confirmPin: values.newPin,
        token: token
      }
      setSpinner(true)
      axios.post(createPinApi(),{...data}).then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message)
          pinChange.resetForm();
          navigate('/')
          setSpinner(false)
        }
        else {
          toast.error(resp.data.message)
          setSpinner(false)
        }
      })
        .catch(() => {
          toast.error(commonMessage.networkError)

        })
    },
  });
  return (
    <>
    <ToastContainer/>
    <section>
        <div className="m-t-3 cus-padd cusheight">
        {spinner ? <Spinner /> : null}
          <div className="row d-flex justify-content-center mt-5 align-content-center">
            <div className="col-sm-4 text-center shadow py-5"  style={{ borderRadius: "5px" }}>
              <img src={Reset} alt='' />
              <h1 className="text-center  mb-3">Create Pin</h1>
              <form className="cus-form" onSubmit={pinChange.handleSubmit}>
                <label className="form-label">Enter New Pin *</label>
                <div className="pin-code">
                  <OtpInput  
                  isInputNum 
                  isInputSecure
                  numInputs={4} 
                   name='newPin'
                   onChange={(e) => { pinChange.setFieldValue("newPin", e) }} 
                   value={pinChange.values.newPin} />
                </div>
                {pinChange.touched.newPin && pinChange.errors.newPin ? (
                  <div style={{ color: 'red', fontSize: '12px' }}>{pinChange.errors.newPin}</div>
                ) : null}
                <label className="form-label mt-2">Confirm New Pin *</label>
                <div className="pin-code">
                  <OtpInput 
                  isInputNum
                  numInputs={4}
                  isInputSecure
                   name='confirmNewPin'
                   onChange={(e) => { pinChange.setFieldValue("confirmNewPin", e) }} 
                   value={pinChange.values.confirmNewPin} />
                </div>
                {pinChange.touched.confirmNewPin && pinChange.errors.confirmNewPin ? (
                  <div style={{ color: 'red', fontSize: '12px' }}>{pinChange.errors.confirmNewPin}</div>
                ) : null}
                <div className="col-sm-12 d-flex  mt-5 justify-content-center">
                  <button type='submit' className="btn btn-primary profile-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default CreatePin;